import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import IconHolder from '../../Helpers/IconHolder';
import './FinalExpensePurchasingProcess.scss';

function PurchasingProcessFooter(props) {
  return (
    <div className="background-image px-0">
      <div className='mt-4'>
        { props.hasTitle && <div className='purchasing-title'><h3><b>How we simplify the Life Insurance Experience</b></h3></div> }
        <Row className='purchasing-content'>
          {props.footerData.data.stepsfooter.map((step, index) =>
            <Col key={index} lg={3} sm={12}>
              <div>
                <div className="d-flex justify-content-center mt-3">
                  <IconHolder icon={step.icon} fontSize={"30px"} viewBox="0 0 30 30" />
                </div>
                <div className='mt-3'><h5><b>{step.title}</b></h5></div>
                <div>
                  {step.paragraphs.map((p, i) => Array.isArray(p) ?
                    buildList(p, i)
                    : <div key={i}><h6>{p}</h6></div>)
                  }
                </div>
              </div>
            </Col>
          )}
        </Row>
      </div>
    </div>
  )
}
export default function PurchasingProcess(props) {
  return (
    <Row className={`final-expense-purchasing-process justify-content-center lightBackground`}>
      <Container className="mt-5 mb-5">
        <Row>
          <Col className="mx-3 mb-4">
         <h2 className= "final-expense-title text-center">{props.data.title}</h2>
            <p className="text-center">{props.data.subtitle}</p>
          </Col>
        </Row>
      {props.data.steps.map((step, index) =>
          <Row key={index} className="mt-3 px-5">
            <Col xs={1} className="d-flex justify-content-center main-final-expense">
              <div className='icon-color'><IconHolder icon={step.icon} viewBox="0 0 25 25" /></div>
            </Col>
            <Col className="d-flex align-items-start justify-content-center flex-column">
              <h3 className="final-expense-name" >{step.title}</h3>
              {step.paragraphs.map((p, i) => Array.isArray(p) ?
                buildList(p, i)
                : <div className='final-expense-content' key={i}>{p}</div>)
              }
            </Col>
          </Row>
        )}
      </Container>
     <PurchasingProcessFooter footerData={props}/>
    </Row>
  );
}

function buildList(list, index) {
  return (
    <ul key={index}>
      {list.map((listItem, i) => Array.isArray(listItem) ?
        buildList(listItem, i) :
        <li key={i}>{listItem}</li>
      )}
    </ul>
  );
}

PurchasingProcess.propTypes = {
  data: PropTypes.shape({
    subtitle: PropTypes.string,
    stepsfooter: PropTypes.array,
  })
}
